module.exports = __webpack_public_path__ + "static/img/n_01.97b1d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/n_01.jpg
// module id = E1li
// module chunks = 0